import { render, staticRenderFns } from "./data-permission-define.vue?vue&type=template&id=1889ba09&scoped=true"
import script from "./data-permission-define.vue?vue&type=script&lang=js"
export * from "./data-permission-define.vue?vue&type=script&lang=js"
import style0 from "./data-permission-define.vue?vue&type=style&index=0&id=1889ba09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889ba09",
  null
  
)

export default component.exports